export default __webpack_public_path__ + "static/media/photo-1502378735452-bc7d86632805.905b3e52.jpeg";